module.exports = __webpack_public_path__ + "static/media/car-speakers.37cebe85.png";